<template>
  <div class="smart-contract-pc" id="smartContract">
    <!-- Banner -->
    <Banner
      :isPcFlag="true"
      :logoFlag="true"
      :pcBgImg="pcBgImg"
      pcTitle="签管一体化合同管理系统"
      pcDesc="串联OA、财务、CRM、EHR等系统，"
      pcSecondDesc="打造业法财一体化，提升企业多系统、多部门间合同管理效率"
      :landingPageName="landingPageName"
      pcBtndesc="申请试用"
      @showDialog="showDialog"
    ></Banner>
    <!-- 深耕于人事场景和分销场景 -->
    <HrAndDistribution :isPcFlag="true" :dataList="HrAndDistributionList"></HrAndDistribution>
    <!-- 穿透合同生命周期的智能化管理方案 -->
    <ContractLifeCycle :isPcFlag="true" :dataList="ContractLifeCycleList"></ContractLifeCycle>
    <!-- 客户成功案例 -->
    <CustomerCase :isPcFlag="true"></CustomerCase>
    <!-- 底部留资 -->
    <ScrollForm
      :show="true"
      @msg="handleShowMsg"
      @setShowSuccessDialog="setShowSuccessDialog"
      :landingPageName="landingPageName"
      title="留资免费领取1个月试用"
      pageName="smartContract"
    />
    <!-- toast提示 -->
    <Message :type="message.type" :title="message.title" :content="message.content" :show.sync="message.show" />
    <!-- 提交成功 -->
    <WeilingSuccessDialog v-if="showSuccessDialog" @closeform="showSuccessDialog = false" />
    <!-- 右侧客服 -->
    <DomainContact @showDialog="showDialog" :landingPageName="landingPageName" />
    <!-- 留资弹框 -->
    <UseDialog ref="dialog" pageName="smartContract" />
    <!-- 底部备案信息 -->
    <Footer />
  </div>
</template>

<script>
import dataList from './dataList'
export default {
  components: {
    Banner: () => import('@/components/Banner.vue'),
    UseDialog: () => import('@/components/UseDialog.vue'),

    HrAndDistribution: () => import('./components/HrAndDistribution.vue'),
    ContractLifeCycle: () => import('./components/ContractLifeCycle.vue'),
    CustomerCase: () => import('./components/CustomerCase.vue'),
    ScrollForm: () => import('../extension/components/pc/ScrollForm.vue'),
    Message: () => import('../extension/components/pc/Message.vue'),
    WeilingSuccessDialog: () => import('@/components/saasApiSuccessForm.vue'),
    DomainContact: () => import('../extension/components/pc/DomainContact.vue'),
    Footer: () => import('../extension/components/pc/Footer.vue'),
  },
  data() {
    return {
      pcBgImg: require('@/assets/images/smart-contract/banner.png'),
      // 落地页名字'e签宝宣传'，因为以上的组件会被多次复用，为了服务商收集数据的时候能够更准确，用这个名字去判断是否需要向服务商发送数据
      landingPageName: 'esignPropagate',
      HrAndDistributionList: dataList.HrAndDistributionList,
      ContractLifeCycleList: dataList.ContractLifeCycleList,
      showSuccessDialog: false,
      message: {
        type: '',
        title: '',
        content: '',
        show: false,
      },
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandle, true)
    // 获取当前元素的父元素设置最小值
    const v = document.getElementById('smartContract').parentNode
    v.style.minWidth = '35.2rem'
  },
  methods: {
    showDialog() {
      this.$refs.dialog.showDialog()
    },
    scrollHandle() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      this.$refs.newHeader && this.$refs.newHeader.scrollHandle()
    },
    handleShowMsg({ type, title, content }) {
      this.message.type = type
      this.message.title = title
      this.message.content = content
      this.message.show = true
    },
    setShowSuccessDialog(v) {
      this.showSuccessDialog = v
    },
  },
}
</script>
<style lang="less">
* > img {
  max-width: 100%;
}

a {
  font-size: 37.5px;
  color: #333;
}

a:hover,
input.error {
  color: #fa465a;
}

.container {
  width: 32rem\9;
}

@media (min-width: 32rem) {
  .main {
    min-width: 32rem;
  }
}

.banner,
.banner video,
.banner .text,
.banner .text .banner_tabbox .tab_listbox,
.con,
.con1,
.con1 .con1_tab .tab_box,
.con2,
.con2 .con2_tab .tab_box,
.con3,
.con4,
.con6,
.footer {
  min-width: 0;
}

.btn {
  display: inline-block;
  padding: 0.16rem 0.32rem;
  margin-bottom: 0;
  font-size: 0.3733rem;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 0.0267rem solid transparent;
  border-radius: 0.1067rem;
}
</style>
